/**
 * ID del contenedor donde se renderizarán los drawers mediante Portal
 * en la vista de TrackingOrder
 */
export const ORDER_LISTING_OPERATIONS_ID = 'ordersListingOperations';

/**
 * Selector CSS para las columnas Trello, necesario para bloquear
 * el scroll cuando se abre un drawer
 */
export const TRELLO_COLUMN_CONTENT_CLASS = '.trelloColumnContent';

